/**
 * Config → Payments field guards (QA):
 * - Payment Window must not be zero
 * - Daily Capture Time must not be 00:00 / zero
 */

/** Normalize API capture-time strings for `<input type="time">` (HH:MM). */
export function normalizeCaptureTimeForInput(raw: string | undefined | null): string {
  if (raw == null) return ''
  const s = String(raw).trim()
  if (!s || s === '0') return ''

  const match = s.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/)
  if (!match) return s

  const hh = match[1].padStart(2, '0')
  const mm = match[2]
  const normalized = `${hh}:${mm}`
  // Treat midnight / all-zero as empty so the field does not display "00:00".
  if (normalized === '00:00') return ''
  return normalized
}

export function isZeroCaptureTime(value: string | undefined | null): boolean {
  if (value == null) return false
  const s = String(value).trim()
  if (!s) return false
  if (s === '0') return true
  return /^(0{1,2}):0{2}(:0{2})?$/.test(s)
}

export function validatePaymentWindow(value: string | undefined | null): true | string {
  if (value == null || String(value).trim() === '') return true
  const n = Number(String(value).trim())
  if (!Number.isFinite(n) || !Number.isInteger(n) || n < 1) {
    return 'Payment Window must be greater than zero'
  }
  return true
}

export function validateCaptureTime(value: string | undefined | null): true | string {
  if (value == null || String(value).trim() === '') return true
  if (isZeroCaptureTime(value)) {
    return 'Daily Capture Time cannot be zero'
  }
  return true
}
